import { useParams } from 'react-router-dom'
import { useAcsFetch } from '../hooks/use-acs-fetch'
import { TransactionDetails } from '../types'
import { checkImageUrlComposerApigeeMigration } from '../utils/transactionMapper'

export const useTransactionDetailsApi = (): {
  fetchTransactionDetails: (
    transactionId: string,
  ) => Promise<TransactionDetails>
  fetchCheckImages: (checkImagesUrl: string) => Promise<[]>
} => {
  const acsFetch = useAcsFetch()
  const acsFetchCheckImage = useAcsFetch({ withCif: true })
  const { id } = useParams<{ id: string }>()

  const fetchTransactionDetails = async (
    transactionId: string,
  ): Promise<TransactionDetails> => {
    const response = await acsFetch<Record<string, TransactionDetails>>(
      `/v1/bank-accounts/transactions/accounts/${id}/details/${transactionId}`,
    )
    if (response.data && response.data.transaction) {
      return checkImageUrlComposerApigeeMigration(id, response.data.transaction)
    }
    throw new Error('No transaction details payload in successful response')
  }

  const fetchCheckImages = async (checkImagesUrl: string): Promise<[]> => {
    const response = await acsFetchCheckImage<Record<string, []>>(
      `${checkImagesUrl}/urls`,
    )
    if (response.data) {
      const key = Object.keys(response.data)[0]
      return response.data[key]
    }
    throw new Error('No check images payload in successful response')
  }

  return { fetchTransactionDetails, fetchCheckImages }
}
